/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import * as THREE from 'three';
import * as marietta from '../..';
import { ITEM_MODE_KEY, ITEM_MODE_NAME_ENG, ITEM_MODE_NO, BUILDING_TYPE_MANSION, BUILDING_TYPE_HOUSE } from '../Constants';
import { SVGSprite } from '../flash/display';
import { ItemInfoCollection } from '../collection';
import { MonicaObject } from '../item';

// 廊下自動生成で作られる部屋のID（建物区分によって配置先レイヤーが異なる。getTargetLayer参照）
const HALLWAY_ROOM_ID: string = 'rom02_01';

export default class FloorLayer {
    floor: number;

    layer_site: marietta.webcad.layer.SiteLayer;

    layer_exterior: marietta.webcad.layer.ItemLayer;

    layer_roomdown1: marietta.webcad.layer.ItemLayer;

    layer_roomdown2: marietta.webcad.layer.ItemLayer;

    layer_room: marietta.webcad.layer.ItemLayer;

    layer_wall: marietta.webcad.layer.ItemLayer;

    layer_upstair: marietta.webcad.layer.UpStairsLayer;

    layer_stair: marietta.webcad.layer.ItemLayer;

    layer_fittingdown1: marietta.webcad.layer.ItemLayer;

    layer_equipment: marietta.webcad.layer.ItemLayer;

    layer_furniture: marietta.webcad.layer.ItemLayer;

    layer_fitting: marietta.webcad.layer.ItemLayer;

    layer_present: marietta.webcad.layer.ItemLayer;

    layer_measure: marietta.webcad.layer.MeasureLayer;

    layer_roof: marietta.webcad.layer.RoofLayer;

    layer_roomname: marietta.webcad.layer.RoomTextLayer;

    layer_column: marietta.webcad.layer.ItemLayer;

    layer_freetext: marietta.webcad.layer.ItemLayer;

    layer_beam: marietta.webcad.layer.ItemLayer;

    layer_group: marietta.webcad.layer.GroupItemLayer;

    layer_lidar_import: marietta.webcad.layer.LidarImportLayer;

    layer_mark: marietta.webcad.layer.ItemLayer;

    x: number;

    y: number;

    allLayers: marietta.webcad.layer.ItemLayer[];

    public spt: SVGSprite;

    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * Constructor
     */
    constructor(_number: number, layerGroup: SVGSprite) {
      this.floor = _number;

      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');

      viewObj.classList.add('svgSprite');
      this.spt = new SVGSprite(viewObj);

      layerGroup.addChild(this.spt);

      this.init();
    }

    /**
     * 初期設定
     */
    init() {
      this.viewObj.setAttribute('id', `floor${this.floor}`);

      // create each ItemLayer in Order
      this.layer_site = new marietta.webcad.layer.SiteLayer(ITEM_MODE_NO.MODE_SITE_NO, ITEM_MODE_NAME_ENG.MODE_SITE_NAME_ENG, ITEM_MODE_KEY.MODE_SITE_KEY, this.spt);
      this.layer_upstair = new marietta.webcad.layer.UpStairsLayer(ITEM_MODE_NO.MODE_UPSTAIR_NO, ITEM_MODE_NAME_ENG.MODE_UPSTAIR_NAME_ENG, ITEM_MODE_KEY.MODE_UPSTAIR_KEY, this.spt);
      this.layer_roomdown1 = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_ROOMDOWN1_NO, ITEM_MODE_NAME_ENG.MODE_ROOMDOWN1_NAME_ENG, ITEM_MODE_KEY.MODE_ROOMDOWN1_KEY, this.spt);
      this.layer_roomdown2 = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_ROOMDOWN2_NO, ITEM_MODE_NAME_ENG.MODE_ROOMDOWN2_NAME_ENG, ITEM_MODE_KEY.MODE_ROOMDOWN2_KEY, this.spt);
      this.layer_stair = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_STAIR_NO, ITEM_MODE_NAME_ENG.MODE_STAIR_NAME_ENG, ITEM_MODE_KEY.MODE_STAIR_KEY, this.spt);
      this.layer_room = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_ROOM_NO, ITEM_MODE_NAME_ENG.MODE_ROOM_NAME_ENG, ITEM_MODE_KEY.MODE_ROOM_KEY, this.spt);
      this.layer_wall = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_WALL_NO, ITEM_MODE_NAME_ENG.MODE_WALL_NAME_ENG, ITEM_MODE_KEY.MODE_WALL_KEY, this.spt);
      this.layer_fittingdown1 = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_FITTINGDOWN1_NO, ITEM_MODE_NAME_ENG.MODE_FITTINGDOWN1_NAME_ENG, ITEM_MODE_KEY.MODE_FITTINGDOWN1_KEY, this.spt);
      this.layer_equipment = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_EQUIPMENT_NO, ITEM_MODE_NAME_ENG.MODE_EQUIPMENT_NAME_ENG, ITEM_MODE_KEY.MODE_EQUIPMENT_KEY, this.spt);
      this.layer_furniture = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_FURNITURE_NO, ITEM_MODE_NAME_ENG.MODE_FURNITURE_NAME_ENG, ITEM_MODE_KEY.MODE_FURNITURE_KEY, this.spt);
      this.layer_fitting = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_FITTING_NO, ITEM_MODE_NAME_ENG.MODE_FITTING_NAME_ENG, ITEM_MODE_KEY.MODE_FITTING_KEY, this.spt);
      this.layer_exterior = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_EXTERIOR_NO, ITEM_MODE_NAME_ENG.MODE_EXTERIOR_NAME_ENG, ITEM_MODE_KEY.MODE_EXTERIOR_KEY, this.spt);
      this.layer_roof = new marietta.webcad.layer.RoofLayer(ITEM_MODE_NO.MODE_ROOF_NO, ITEM_MODE_NAME_ENG.MODE_ROOF_NAME_ENG, ITEM_MODE_KEY.MODE_ROOF_KEY, this.spt);
      this.layer_present = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_PRESENT_NO, ITEM_MODE_NAME_ENG.MODE_PRESENT_NAME_ENG, ITEM_MODE_KEY.MODE_PRESENT_KEY, this.spt);
      this.layer_measure = new marietta.webcad.layer.MeasureLayer(ITEM_MODE_NO.MODE_MEASURE_NO, ITEM_MODE_NAME_ENG.MODE_MEASURE_NAME_ENG, ITEM_MODE_KEY.MODE_MEASURE_KEY, this.spt, this);
      this.layer_roomname = new marietta.webcad.layer.RoomTextLayer(ITEM_MODE_NO.MODE_ROOMNAME_NO, ITEM_MODE_NAME_ENG.MODE_ROOMNAME_NAME_ENG, ITEM_MODE_KEY.MODE_ROOMNAME_KEY, this.spt);
      this.layer_column = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_COLUMN_NO, ITEM_MODE_NAME_ENG.MODE_COLUMN_NAME_ENG, ITEM_MODE_KEY.MODE_COLUMN_KEY, this.spt);
      this.layer_beam = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_BEAM_NO, ITEM_MODE_NAME_ENG.MODE_BEAM_NAME_ENG, ITEM_MODE_KEY.MODE_BEAM_KEY, this.spt);
      this.layer_group = new marietta.webcad.layer.GroupItemLayer(ITEM_MODE_NO.MODE_GROUP_NO, ITEM_MODE_NAME_ENG.MODE_GROUP_NAME_ENG, ITEM_MODE_KEY.MODE_GROUP_KEY, this.spt);
      this.layer_freetext = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_FREETEXT_NO, ITEM_MODE_NAME_ENG.MODE_FREETEXT_NAME_ENG, ITEM_MODE_KEY.MODE_FREETEXT_KEY, this.spt);
      this.layer_mark = new marietta.webcad.layer.ItemLayer(ITEM_MODE_NO.MODE_MARK_NO, ITEM_MODE_NAME_ENG.MODE_MARK_NAME_ENG, ITEM_MODE_KEY.MODE_MARK_KEY, this.spt);
      this.layer_lidar_import = new marietta.webcad.layer.LidarImportLayer(ITEM_MODE_NO.MODE_LIDAR_NO, ITEM_MODE_NAME_ENG.MODE_LIDAR_NAME_ENG, ITEM_MODE_KEY.MODE_LIDAR_KEY, this.spt);

      // 全レイヤーの登録
      this.allLayers = [this.layer_site, this.layer_exterior, this.layer_column, this.layer_beam, this.layer_stair, this.layer_room, this.layer_wall, this.layer_fittingdown1, this.layer_equipment, this.layer_furniture, this.layer_fitting, this.layer_present, this.layer_measure, this.layer_roomname, this.layer_group, this.layer_upstair, this.layer_roomdown1, this.layer_roomdown2, this.layer_roof, this.layer_freetext, this.layer_mark, this.layer_lidar_import];
    }

    /*
     * TODO
     * 削除用関数を用意（k.kubonaka)
     * 仮で実装してみました（morimoto）
     */
    public remove(): void {
      this.spt.element.remove();
    }

    /*
     * 表示
     */
    public show(showRoofLayer: boolean = true): void {
      if (showRoofLayer) {
        this.layer_roof.spt.show();
      } else {
        this.layer_roof.spt.hide();

        // カレントアイテムが屋根で屋根モード以外の時は、カレントをなくす
        if (marietta.webcad.WebCADGlobal.itemManager.currentItem instanceof marietta.webcad.item.Roof) {
          marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        }
      }

      this.spt.show();
    }

    /**
     * 部屋分割処理用の初期化
     */
    formatLayersNewRoomCreations() {
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;

      // 特定部屋の初期化
      this.layer_room.format();
      this.layer_wall.format();
    }

    /*
     * 非表示
     */
    public hide(): void {
      this.spt.hide();
    }

    /*
     * TODO
     */
    public before(target: Element): void {
      this.spt.element.before(target);
    }

    /*
     * TODO
     */
    public after(target: Element): void {
      this.spt.element.after(target);
    }

    /**
     * ターゲットレイヤーの取得
     * @param レイヤーのkey
     * @return ItemLayer
     */
    getTargetLayer(id: string): marietta.webcad.layer.ItemLayer {
      let targetLayer: any;
      for (let i: number = 0; i < this.allLayers.length; i += 1) {
        targetLayer = this.allLayers[i];
        // 廊下とポーチは別レイヤーに生成する
        // ポーチ、バルコニー
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE && (id === 'rom01_01' || id === 'rom18_01')) {
          return this.layer_roomdown1;
        }
        // 廊下、広縁
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_HOUSE && (id === 'rom02_01' || id === 'rom13_01')) {
          return this.layer_roomdown2;
        }

        // 開口
        if (id === 'fit02_01' || id === 'fit02_07') {
          return this.layer_fittingdown1;
        }

        if (id.indexOf(targetLayer.modeKey) > -1) {
          return targetLayer;
        }
      }
      return null;
    }

    /**
     * 階の境界線情報の取得
     * @param boolean 寸法線レイヤーを含めるか否か
     * @return object
     * */
    getMinMaxPointVisible(includeMeasure: boolean = false, includeExterior: boolean = true) {
      let retObj;
      let targetLayer: marietta.webcad.layer.ItemLayer;
      let boundObj;
      let itemBound;
      const excludeLayerList = [];
      excludeLayerList.push(this.layer_group, this.layer_roof, this.layer_upstair);
      if (!includeMeasure) excludeLayerList.push(this.layer_measure);
      if (!includeExterior) excludeLayerList.push(this.layer_site, this.layer_exterior);
      const layerList = this.getAllLayerList(excludeLayerList);
      let allChildren = [];
      let k: number;

      for (let i: number = 0; i < layerList.length; i += 1) {
        targetLayer = layerList[i] as marietta.webcad.layer.ItemLayer;
        if (targetLayer.isItemInMe()) { // 中身がない場合はスキップ
          // 部屋の場合
          if (targetLayer === this.layer_room) {
            allChildren = targetLayer.getAllChildren();

            // 部屋レイヤー内の部屋を1つずつ
            for (k = 0; k < allChildren.length; k += 1) {
              boundObj = (allChildren[k] as marietta.webcad.item.MonicaObject).spt.getBoundingClientRect();

              itemBound = {};
              itemBound.minX = boundObj.left;
              itemBound.minY = boundObj.top;
              itemBound.maxX = boundObj.left + boundObj.width;
              itemBound.maxY = boundObj.top + boundObj.height;
              retObj = this.renewLimitList(retObj, itemBound);
            }
          } else {
          // その他のレイヤーは純粋にレイヤーの境界線

            // boundObj = targetLayer.viewObj.getBoundingClientRect();
            boundObj = targetLayer.spt.getBoundingClientRect();
            itemBound = {};
            itemBound.minX = boundObj.left;
            itemBound.minY = boundObj.top;
            itemBound.maxX = boundObj.left + boundObj.width;
            itemBound.maxY = boundObj.top + boundObj.height;
            retObj = this.renewLimitList(retObj, itemBound);
          }
        }
      }
      return retObj;
    }

    /**
     * 階の部屋境界線情報の取得
     * @param ポーチを含む
     * @param 階段を含む
     * */
    getRoomMinMaxPointVisible(includePorch: boolean = false, includeStair: boolean = true) {
      let retObj;
      let targetLayer: marietta.webcad.layer.ItemLayer;
      let boundObj;
      let itemBound;
      const excludeLayerList = [];
      excludeLayerList.push(this.layer_group, this.layer_measure, this.layer_site, this.layer_exterior, this.layer_equipment, this.layer_furniture, this.layer_roof);
      const layerList = this.getAllLayerList(excludeLayerList);
      let allChildren = [];
      let k: number;

      // 部屋の場合
      allChildren = this.layer_room.getAllChildren().concat(this.layer_roomdown1.getAllChildren(), this.layer_roomdown2.getAllChildren());

      for (let i: number = 0; i < layerList.length; i += 1) {
        targetLayer = layerList[i] as marietta.webcad.layer.ItemLayer;
        if (targetLayer.isItemInMe()) { // 中身がない場合はスキップ
          // 部屋レイヤー内の部屋を1つずつ
          if (targetLayer === this.layer_room) {
            for (k = 0; k < allChildren.length; k += 1) {
              if (!(!includePorch && ((allChildren[k] as marietta.webcad.item.Room).itemInfo.id.indexOf('rom01') > -1))) {
                boundObj = (allChildren[k] as marietta.webcad.item.MonicaObject).spt.getBoundingClientRect();

                itemBound = {};
                itemBound.minX = boundObj.left;
                itemBound.minY = boundObj.top;
                itemBound.maxX = boundObj.left + boundObj.width;
                itemBound.maxY = boundObj.top + boundObj.height;
                retObj = this.renewLimitList(retObj, itemBound);
              }
            }
          } else if (includeStair && (targetLayer === (this.layer_stair))) {
            boundObj = targetLayer.spt.getBoundingClientRect();
            itemBound = {};
            itemBound.minX = boundObj.left;
            itemBound.minY = boundObj.top;
            itemBound.maxX = boundObj.left + boundObj.width;
            itemBound.maxY = boundObj.top + boundObj.height;
            retObj = this.renewLimitList(retObj, itemBound);
          }
        }
      }
      return retObj;
    }

    /**
     * 境界線情報の取得
     * */
    renewLimitList=(motoObj, renewObj) => {
      if (motoObj === undefined || Number.isNaN(motoObj.minX) || Number.isNaN(motoObj.minY) || Number.isNaN(motoObj.maxX) || Number.isNaN(motoObj.maxY)) return renewObj;
      if (renewObj === undefined || Number.isNaN(renewObj.minX) || Number.isNaN(renewObj.minY) || Number.isNaN(renewObj.maxX) || Number.isNaN(renewObj.maxY)) return motoObj;

      if (renewObj.minX < motoObj.minX) { motoObj.minX = renewObj.minX; }
      if (renewObj.minY < motoObj.minY) { motoObj.minY = renewObj.minY; }
      if (renewObj.maxX > motoObj.maxX) { motoObj.maxX = renewObj.maxX; }
      if (renewObj.maxY > motoObj.maxY) { motoObj.maxY = renewObj.maxY; }
      return motoObj;
    }

    /**
     * レイヤー一覧を返す
     * @exclude Array リストから省くレイヤー一覧
     * */
    getAllLayerList(exclude = null) {
      const retList = [];
      let k: number;
      if (exclude == null) exclude = [];

      let includeInList: boolean = true;
      for (let i: number = 0; i < this.allLayers.length; i += 1) {
        includeInList = true;
        for (k = 0; k < exclude.length; k += 1) {
          if (this.allLayers[i] === exclude[k]) {
            includeInList = false;
            break;
          }
        }
        if (includeInList) {
          retList.push(this.allLayers[i]);
        }
      }
      return retList;
    }

    /**
     * アイテムキーよりレイヤーを取得
     * @type 'modeNo', 'modeName', 'modeKey'
     * @modeKey キー文字列
     */
    getLayerByKey(type: String, value: number) {
      // 全レイヤーを検索
      const layerList = this.getAllLayerList();
      for (let i = 0, len = layerList.length; i < len; i += 1) {
        if (((layerList[i] as any) instanceof marietta.webcad.layer.ItemLayer)) {
          if (Object.prototype.hasOwnProperty.call(layerList[i], type)) {
            if (layerList[i][type as any] === value) {
              return layerList[i];
            }
          }
        }
      }
      return null;
    }

    /**
     * LocalToGlobal
     * @param Point
     * @return Point
     */
    // eslint-disable-next-line class-methods-use-this
    localToGlobal(motoPoint: marietta.core.Point): marietta.core.Point {
      // TODO:実際の変換を入れる
      return motoPoint;
    }

    /**
    * アイテム一覧の取得
    * @return Array アイテム一覧
    */
    getAllItems() {
      let retList = [];
      const layerList = this.getAllLayerList();
      let tarLayer: marietta.webcad.layer.ItemLayer;
      for (let i: number = 0; i < layerList.length; i += 1) {
        tarLayer = layerList[i];
        retList = retList.concat(tarLayer.getAllChildren());
      }
      return retList;
    }

    /**
     *
     * @param guid
     * @returns
     */
    getItemWithGuid(guid:string) {
      let item = null;
      const layerList = this.getAllLayerList();
      let tarLayer: marietta.webcad.layer.ItemLayer;
      for (let i: number = 0; i < layerList.length; i += 1) {
        tarLayer = layerList[i];
        item = tarLayer.getChildrenWithGuid(guid);
        if (item) break;
      }
      return item;
    }

    /**
     * 全てのアイテムを動かす
     * @numX Number X軸移動量
     * @numY Number Y軸移動量
     * */
    moveAllItems(moveX: number, moveY: number): void {
      const layerList = this.getAllLayerList();
      for (let i: number = 0; i < layerList.length; i += 1) {
        if (layerList[i] instanceof marietta.webcad.layer.GroupItemLayer || layerList[i] instanceof marietta.webcad.layer.LidarImportLayer) {
          continue;
        } else {
          (layerList[i] as marietta.webcad.layer.ItemLayer).moveAllItems(moveX, moveY);
        }
      }
    }

    /**
     * 建具アイテムの初期化
     */
    initFittingLayer(): void {
      this.layer_fitting.removeAllChildren();
      this.layer_fittingdown1.removeAllChildren();
    }

    /**
     * 住宅設備アイテムの初期化
     */
    initEquipmentLayer(): void {
      this.layer_equipment.removeAllChildren();
    }

    /**
     * 廊下アイテムの初期化
     * 廊下の配置先レイヤーは建物区分（getTargetLayer参照）によって異なり、
     * かつ建物区分は物件ごとに後から変わりうるため、単一レイヤーの固定削除ではなく
     * 廊下が配置されうる全レイヤーから横断的に削除する。
     */
    initRoomdownLayer(): void {
      this.layer_room.removeChildrenByCode(HALLWAY_ROOM_ID);
      this.layer_roomdown1.removeChildrenByCode(HALLWAY_ROOM_ID);
      this.layer_roomdown2.removeChildrenByCode(HALLWAY_ROOM_ID);
    }

    /**
     * レイヤーのマウス操作制御
     * ※コントローラーには影響ない
     */
    enableItemMouseActions(value: boolean): void {
      const layerList = this.getAllLayerList();
      let targetLayer: marietta.webcad.layer.ItemLayer;
      for (let i: number = 0; i < layerList.length; i += 1) {
        targetLayer = layerList[i] as marietta.webcad.layer.ItemLayer;
        targetLayer.spt.mouseEnabled = value;
      }
    }

    /**
     * 境界線情報の取得
     * */
    renewList(motoObj:THREE.Box2, renewObj:THREE.Box2) {
      if (motoObj == null) return renewObj;
      if (renewObj == null) return motoObj;
      return motoObj.union( renewObj );
    }

    /**
     * 階の境界線情報の取得
     * */
    getSVGMinMaxPointVisible():THREE.Box2 {
      let allChildren:(ItemInfoCollection | MonicaObject)[] = [];
      let retObj:THREE.Box2;
      const calculateItemBoud = (layer, getSptBound: boolean = false) => {
        allChildren = layer.getAllChildren(false, true);
        if (allChildren.length > 0 || getSptBound) {
          const boundObj = layer.spt.getBoundingClientRect();
          if (boundObj.width > 0) {
            const itemBound:THREE.Box2 = new THREE.Box2();
            itemBound.setFromPoints([new THREE.Vector2(boundObj.left, boundObj.top), new THREE.Vector2(boundObj.left + boundObj.width, boundObj.top + boundObj.height)]);
            retObj = this.renewList(retObj, itemBound);
          }
        }
        return retObj;
      };
      const layerList = this.getAllLayerList();
      let k: number;
      for (let i: number = 0; i < layerList.length; i += 1) {
        const targetLayer = layerList[i] as marietta.webcad.layer.ItemLayer;
        // 中身がない場合はスキップ
        if (targetLayer.isItemInMe() === false && !(targetLayer instanceof marietta.webcad.layer.MeasureLayer)) continue;
        // 部屋の場合
        if (targetLayer === this.layer_room) {
          allChildren = targetLayer.getAllChildren();
          // 部屋レイヤー内の部屋を1つずつ
          for (k = 0; k < allChildren.length; k += 1) {
            // const isAutoRoom = allChildren[k] instanceof ItemInfoCollection ? (allChildren[k] as ItemInfoCollection).is_auto_created_item : (allChildren[k] as MonicaObject).itemInfo.is_auto_created_item;
            // if (excludeAutoRoom && isAutoRoom) continue;
            const boundObj = (allChildren[k] as marietta.webcad.item.MonicaObject).spt.getBoundingClientRect();
            const itemBound:THREE.Box2 = new THREE.Box2();
            itemBound.setFromPoints([new THREE.Vector2(boundObj.left, boundObj.top), new THREE.Vector2(boundObj.left + boundObj.width, boundObj.top + boundObj.height)]);
            retObj = this.renewList(retObj, itemBound);
          }
        } else if (targetLayer === this.layer_measure) {
          retObj = calculateItemBoud(targetLayer, true);
        } else if (targetLayer === this.layer_roomname) {
          continue;
        } else {
          // その他のレイヤーは純粋にレイヤーの境界線
          retObj = calculateItemBoud(targetLayer);
        }
      }
      // const guidLayer = marietta.webcad.WebCADGlobal.layerGroup.guide;
      // retObj = calculateItemBoud(guidLayer);
      return retObj;
    }
}
